import { useEffect } from 'react';
import { trackTilesList } from 'utilities';

/**
 * Hook for tracking tiles container view events
 * @param component - The content API model containing tile data
 * @param blockType - The block type to match against content type
 * @param delay - Optional delay in milliseconds before tracking (default: 100ms)
 */
export const useTilesTracking = (component: ContentApiModel, blockType: string, brand: Theme, delay: number = 200) => {
	const { content } = component ?? {};

	useEffect(() => {
		if (content.contentType === blockType) {
			// Add a delay to ensure useTrackPage events are sent first
			const timeoutId = setTimeout(() => {
				trackTilesList(component, brand);
			}, delay);

			// Cleanup timeout on component unmount or dependency change
			return () => {
				clearTimeout(timeoutId);
			};
		}
	}, [content, component, blockType, brand, delay]);
};
